import TeamPersonRow from "../components/TeamPersonRow";
import add from "../assets/teams-add-team-member.svg"
import {useEffect, useState} from "react";
import GenericDialog from "../components/GenericDialog";
import SubscriptionNeededPopup from "../components/SubscriptionNeededPopup";
import profile_api from "../api/protected/profile";


const TeamPeopleContainer = (props) => {

    const people = props.people;
    const updatePeople = props.updatePeople;
    const deleteFn = props.deletePerson;
    const editor = props.editor;
    const [showDeletePopup, setShowDeletePopup] = useState(false)
    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);

    const [subscription, setSubscription] = useState(null);

    const [storedEv, setStoredEv] = useState(null)
    const [storedIdx, setStoredIdx] = useState(0)
    const buttons = [{"text":"Delete", "id": "1"}, {"text":"Cancel", "id": "2"}];

    const roles = [
        {"id": 1, "name": "Team Member"},
        {"id": 2, "name": "Team Leader"},
        {"id": 3, "name": "Stakeholder"},
    ]

    const createBlankTeamPerson = (ev) => {
        if(!ev) return;
        let person = {
            "id": "new",
            "name": "",
            "role": 1,
            "color": "237842",
            "email": "",
            "organisation_id": props.organisation_id
        }
        updatePeople(person)
    }

    const deletePerson = (ev, idx) => {
        setStoredEv(ev)
        setStoredIdx(idx)
        setShowDeletePopup(true)
    }

    const handleDeleteDialogue = (result) => {
        if (!editor) return;
        if (result === "1") {
            deleteFn(storedEv, storedIdx)
        }
        setStoredEv(null)
        setStoredIdx(0)
        setShowDeletePopup(false)
    }

    const updatePerson = (ev, idx, key) => {
        let person = people[idx]
        switch (key) {
            case "name":
                person.name = ev.target.value;
                break;
            case "role":
                const newRole = parseInt(ev.target.value);
                if (subscription !== null && subscription < 1 && newRole === 3) {
                    // count stakeholders excluding the current row
                    const stakeholderCount = people.filter((p, i) =>
                        parseInt(p.role) === 3 && i !== idx
                    ).length;

                    if (stakeholderCount >= 5) {
                        setShowSubscriptionPopup(true);
                        return;
                    }
                }

                person.role = newRole;
                break;
            case "email":
                person.email = ev.target.value;
                break;
            default:
                break;
        }
        props.updatePerson(person, idx)
    }

    const handleEnterContext = (ev, idx) => {
        if(!ev) return;
        if(ev.key !== "Enter") return;

        switch (ev.target.id) {
            case `person-name-input${idx}`:
                document.getElementById(`person-role-input${idx}`).focus();
                break;
            case `person-role-input${idx}`:
                document.getElementById(`person-email-input${idx}`).focus();
                break;
            case `person-email-input${idx}`:
                document.getElementById(`person-name-input${idx}`).focus();
                break;
            default:
                break;
        }
    }

    const getSubscription = () => {
        let response = profile_api.getSubscription();
        response.then(response => {
            setSubscription(response.data.subscription.type);
        }).catch(() => {});
    };

    useEffect(() => {
        getSubscription();
    }, []);

    return (
        <div className="add-person-container">
            <div className="add-person-form-title-container">
                <div className="add-person-form-title">{editor ? "ADD TEAM MEMBER" : "Team Members"}</div>
                {editor ?
                    <div className="team-people-add-container" onClick={createBlankTeamPerson}>
                        <img src={add} alt="Add Team Person"/>
                    </div>
                    : null
                }
            </div>
            {people && people.map((person, idx) => {
                return (
                    <>
                        <TeamPersonRow person={person}
                                       people={people}
                                       handleEnterContext={handleEnterContext.bind(this)}
                                       updatePerson={updatePerson.bind(this)}
                                       deletePerson={deletePerson.bind(this)}
                                       roles={roles}
                                       idx={idx}
                                       key={idx}
                                       editor={editor}
                        />
                        {showDeletePopup ?
                            <GenericDialog title="Delete Team Person"
                                           text="Are you sure you want to delete this person?"
                                           buttons={buttons}
                                           result={handleDeleteDialogue.bind(this)}
                            /> : null
                        }
                    </>
                )
            })}
            {showSubscriptionPopup && (
                <SubscriptionNeededPopup
                    onClose={() => setShowSubscriptionPopup(false)}
                />
            )}
        </div>
    )
}

export default TeamPeopleContainer;